import React from "react";

export const TableContext =
    React.createContext({
        headerId: "null",
        setHeaderId: (string:string ) => {},
    });